
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Crown, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

interface SubscriptionBadgeProps {
  status: string;
  isAdmin?: boolean;
}

export function SubscriptionBadge({ status, isAdmin = false }: SubscriptionBadgeProps) {
  // Don't show premium plans for admin users
  if (isAdmin) {
    return null;
  }
  
  const getPlanDetails = (status: string) => {
    switch (status) {
      case 'premium':
        return {
          label: 'Premium',
          color: 'bg-grace-dark text-white',
          description: 'You are enjoying all premium features'
        };
      case 'church':
        return {
          label: 'Church',
          color: 'bg-grace-orange text-white',
          description: 'You have access to church management features'
        };
      default:
        return {
          label: 'Free',
          color: 'bg-secondary text-secondary-foreground',
          description: 'Upgrade to unlock premium features'
        };
    }
  };

  const planDetails = getPlanDetails(status);

  return (
    <div className="space-y-4 pb-4">
      <div className="flex flex-col items-center space-y-4">
        <Badge className={`${planDetails.color} px-3 py-1 text-sm font-medium`}>
          <Crown className="w-4 h-4 mr-1 inline-block" />
          {planDetails.label} Plan
        </Badge>
        <p className="text-sm text-center text-app-text-secondary">
          {planDetails.description}
        </p>
        {status === 'free' && (
          <Link to="/premium">
            <Button 
              variant="outline" 
              className="group border-app-border text-app-text-primary hover:bg-app-accent hover:text-app-accent-foreground"
            >
              View Plans
              <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-0.5 transition-transform" />
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
}
